import React from 'react';

import Skeleton, { SKELETON_WIDTHS } from 'buyside/components/presentation/Skeleton/skeleton';

import { times } from 'buyside/util/lodashAlt';

import styles from '../homePageStyles.scss';

const HomePageIdeaUpdateCardLoading: React.FC = () => (
  <>
    {times(20).map(num => (
      <div className={styles.item} key={num}>
        <div className={styles.innerItem}>
          <div>
            <span className={styles.itemTitle}>
              <Skeleton width={SKELETON_WIDTHS.ONE_THIRD} />
            </span>
            <span className={styles.assetSymbol}>
              <Skeleton width={SKELETON_WIDTHS.SMALL} />
            </span>
            <div className={styles.impact}>
              <Skeleton width={SKELETON_WIDTHS.SMALL} />
            </div>
            <p>
              <Skeleton />
              <Skeleton />
              <Skeleton />
            </p>
            <div className={styles.ideaUpdateChanges}>
              <Skeleton />
            </div>
            <div className={styles.authorInfo}>
              <span className={styles.authorName}>
                <Skeleton width={SKELETON_WIDTHS.SMALL} />
              </span>
              <>
                <span className={styles.authorEmployer}>
                  <Skeleton width={SKELETON_WIDTHS.SMALL} />
                </span>
              </>
            </div>
          </div>
          <p className={styles.postedAt}>
            <Skeleton width={SKELETON_WIDTHS.SMALL} />
          </p>
        </div>
      </div>
    ))}
  </>
);

export default HomePageIdeaUpdateCardLoading;
